import serverConnection from '../common/server-connection.js';
import errorMixin from "../components/error.mixin";

export default function() {
  var miindex = new Vue({
    el: 'main',
    mixins: [errorMixin],
    data: {
      categories: [],
      programs: ["","",""],
      siteLang: site_lang,
      point_types: [],
    },
    computed: {
      pointTypesObject: function(){
        var object = {};
        var that = this;

        $(that.point_types).each(function(){
          object[this.id] = this;
        });

        return object;
      },
    },
    created: function () {
      var that = this;
      var data = {};
      var url = site_lang+"/mi/programs?featured=1&page=1&per_page=99";
      var method = "GET";

      serverConnection(data, url, method, function(res, xhr){
        if(res.meta.result === "success") {
          that.categories = res.mi_categories;
          that.programs = res.programs;
          that.point_types = res.point_types;

          Vue.nextTick(function () {
            $('.image-placeholder, .content-placeholder').hide();
            $('.program-card-image, .card-content').show();
          });
        }
      });
    },
    methods: {
      category_img: function(index) {
        let category = this.categories.find(o => o.id == index);
        return category.logo;
      }
    }
  });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/miindex.js